Vue.component('feed-list', require('./vue/feed-list').default);